import { BudgetRequestPlanningStatus } from '~/utils/interfaces';
import { MiniFdStatus } from '~/models/services/minifd';

function normalizeRequestType(requestType: string | number | undefined | null): string | undefined {
    if (requestType === undefined || requestType === null) {
        return undefined;
    }

    return requestType.toString();
}

export function isNewProjectFlow(requestType: string | number | undefined | null): boolean {
    const normalized = normalizeRequestType(requestType);

    return normalized === BudgetRequestPlanningStatus.NEW_PROJECT.toString()
        || normalized === BudgetRequestPlanningStatus.NEW_PROJECT_EXISTING_GLOBAL_ID.toString();
}

export function isBrandNewProject(requestType: string | number | undefined | null): boolean {
    return normalizeRequestType(requestType) === BudgetRequestPlanningStatus.NEW_PROJECT.toString();
}

export function isNewProjectExistingGlobalId(requestType: string | number | undefined | null): boolean {
    return normalizeRequestType(requestType) === BudgetRequestPlanningStatus.NEW_PROJECT_EXISTING_GLOBAL_ID.toString();
}

export function shouldRelaxNewProjectExistingGlobalIdEligibility(status: string | number | undefined | null): boolean {
    if (status === undefined || status === null || status === '') {
        return false;
    }

    const normalizedStatus = status.toString();

    return normalizedStatus === MiniFdStatus.DRAFT.toString()
        || normalizedStatus === MiniFdStatus.SUBMITTED.toString();
}
